<template>
    <Form ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="80" class="modify-pass-view absolute-center">
        <FormItem label="原密码" prop="password" :label-width="100">
            <Input type="password" v-model="formCustom.password" @keyup.enter.native="handleSubmit"></Input>
        </FormItem>
        <FormItem label="新密码" prop="newPassword" :label-width="100">
            <Input type="password" v-model="formCustom.newPassword" @keyup.enter.native="handleSubmit"></Input>
        </FormItem>
        <FormItem label="再次输入新密码" prop="repeatNewPass" :label-width="100">
            <Input type="password" v-model="formCustom.repeatNewPass" @keyup.enter.native="handleSubmit"></Input>
        </FormItem>
        <FormItem class="pass-submit">
            <Button type="primary" @click="handleSubmit('formCustom')">确认提交</Button>
        </FormItem>
    </Form>
</template>

<script>
import { findPassword } from '@/graphql/graphql.js';
import Cookies from 'js-cookie';
export default {
    data() {
        // 密码验证
        const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('密码不能为空'));
            } else if (value !== this.formCustom.newPassword) {
                callback(new Error('两次密码输入不一致'));
            } else {
                callback();
            }
        };
        return {
            formCustom: {
                password: '',
                newPassword: '',
                repeatNewPass: ''
            },
            ruleCustom: {
                password: [
                    { required: true, message: '密码不能为空', trigger: 'blur' }
                ],
                newPassword: [
                    { required: true, message: '密码不能为空', trigger: 'blur' }
                ],
                repeatNewPass: [
                    { validator: validatePassCheck, trigger: 'blur' }
                ]
            }
        };
    },

    mounted() {
        window.sessionStorage.removeItem('receiptList');
    },

    methods: {
        handleSubmit() {
            this.$refs.formCustom.validate((valid) => {
                if (valid) {
                    this.$apollo.mutate({
                        mutation: findPassword,
                        variables: {
                            supplierNo: Cookies.getJSON('USER-INFO').supplierNo,
                            password: this.formCustom.password,
                            newPassword: this.formCustom.newPassword
                        }
                    }).then(res => {
                        const data = res.data.findPassword;
                        if (data && data.code === 200) {
                            this.$refs.formCustom.resetFields();
                            this.$setNotice(data.message);
                        } else {
                            this.$setNotice(data.message);
                        }
                    });
                }
            });
        }
    }
};
</script>

<style lang="stylus">

@import '../assets/stylus/views/modify-pass.styl'

</style>



// WEBPACK FOOTER //
// src/views/ModifyPass.vue